<template>
  <div class="h-full w-full flex flex-col items-center">
    <div class="">
      <img src="/logo/saraf-logo-white.svg" alt="Saraf Logo" />
    </div>
    <div
      class="h-full flex-y-center justify-center flex-col my-auto text-center"
    >
      <h1
        class="text-white text-2xl font-interDisplay font-semibold text-center"
      >
        {{ $t("mobile_title") }}
      </h1>
      <p class="text-gray-450 text-base mt-2">{{ $t("mobile_subtitle") }}</p>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
